module.exports = __webpack_public_path__ + "static/media/millenialv2.f00af1b0.png";